module.exports = __webpack_public_path__ + "img/Fondo_Web_optimoDos.c1890f69.svg";